
    import { mapGetters } from 'vuex';
    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
    import {
        faInfoCircle as farInfoCircle,
    } from '@fortawesome/pro-regular-svg-icons/faInfoCircle';

    import {
        faArrowAltUp as fasArrowAltUp,
    } from '@fortawesome/pro-solid-svg-icons/faArrowAltUp';

    import JobCardSimilarPayDetailed from '@/components/Job/JobCard/JobCardSimilarPayDetailed';

    export default {
        name: 'JobViewPaySummary',

        components: {
            FontAwesomeIcon,
            JobCardSimilarPayDetailed,
        },

        data() {
            return {
                icons: {
                    farInfoCircle,
                    fasArrowAltUp,
                },
            };
        },

        computed: {
            ...mapGetters('job', {
                $_pay: 'pay',
                $_payDescription: 'payDescription',
            }),
        },
    };
